module.exports = __webpack_public_path__ + "static/media/default_icon.fa782533.svg";